import lockupLight from "./assets/cedrum-lockup.svg";
import lockupDark from "./assets/cedrum-lockup-invert.svg";
import markLight from "./assets/cedrum-mark.svg";
import markDark from "./assets/cedrum-mark-invert.svg";

export const CEDRUM_BRAND_LOGOS = Object.freeze({
  lockup: Object.freeze({
    light: lockupLight,
    dark: lockupDark,
  }),
  mark: Object.freeze({
    light: markLight,
    dark: markDark,
  }),
});
